import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// Only import service worker in production to avoid development issues
// import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Service worker handling - completely disabled in development
if (process.env.NODE_ENV === 'production') {
  // In production, dynamically import and register service worker
  import('./serviceWorkerRegistration').then((serviceWorkerRegistration) => {
    serviceWorkerRegistration.register();
  });
} else {
  // In development, completely disable service worker and clear all registrations
  console.log('🧹 Development mode: Service worker completely disabled');
  console.log('🧹 If the page still hangs, please:');
  console.log('🧹 1. Press Ctrl+Shift+Delete to clear browser cache');
  console.log('🧹 2. Press Ctrl+Shift+R for hard refresh');
  console.log('🧹 3. Or close all tabs and reopen the app');
  
  // Aggressively clear any existing service workers
  if ('serviceWorker' in navigator) {
    // Clear existing registrations
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      console.log(`🧹 Found ${registrations.length} service worker registrations to clear`);
      registrations.forEach((registration) => {
        registration.unregister();
        console.log('🧹 Cleared service worker registration:', registration.scope);
      });
    });
    
    // Also try to clear the controller if it exists
    if (navigator.serviceWorker.controller) {
      console.log('🧹 Clearing active service worker controller');
      navigator.serviceWorker.controller.postMessage({ type: 'SKIP_WAITING' });
    }
    
    // Force reload if service worker is still active after a delay
    setTimeout(() => {
      if (navigator.serviceWorker.controller) {
        console.log('🧹 Service worker still active, forcing page reload');
        window.location.reload();
      }
    }, 1000);
    
    // Additional: Try to prevent any new service worker from being registered
    const originalRegister = navigator.serviceWorker.register;
    navigator.serviceWorker.register = function() {
      console.log('🧹 Blocked service worker registration attempt');
      return Promise.reject(new Error('Service worker registration blocked in development mode'));
    };
    
    // Also block the serviceWorkerRegistration.ts file from loading
    console.log('🧹 Blocking service worker registration file from loading');
    
    // Block the serviceWorkerRegistration.ts file completely
    const originalFetch = window.fetch;
    window.fetch = function(input: RequestInfo | URL, init?: RequestInit) {
      const url = typeof input === 'string' ? input : input.toString();
      if (url.includes('serviceWorkerRegistration')) {
        console.log('🧹 Blocked fetch of serviceWorkerRegistration');
        return Promise.reject(new Error('Service worker registration fetch blocked'));
      }
      return originalFetch(input, init);
    };
    
    // Also try to prevent the file from being imported
    if (typeof (window as any).import === 'function') {
      const originalImport = (window as any).import;
      (window as any).import = function(url: string) {
        if (url.includes('serviceWorkerRegistration')) {
          console.log('🧹 Blocked import of serviceWorkerRegistration');
          return Promise.reject(new Error('Service worker registration import blocked'));
        }
        return originalImport(url);
      };
    }
    
    // MOST IMPORTANT: Block the serviceWorkerRegistration.ts file from being loaded at all
    console.log('🧹 Blocking serviceWorkerRegistration.ts file completely');
    
    // Override the import to prevent the file from being loaded
    const originalImport = (window as any).import;
    (window as any).import = function(url: string) {
      if (url.includes('serviceWorkerRegistration')) {
        console.log('🧹 Blocked import of serviceWorkerRegistration');
        return Promise.reject(new Error('Service worker registration import blocked'));
      }
      if (originalImport) {
        return originalImport(url);
      }
      return Promise.reject(new Error('Dynamic imports blocked in development mode'));
    };
    
    // Also block any script tags that might load the service worker
    const originalCreateElement = document.createElement;
    document.createElement = function(tagName: string) {
      const element = originalCreateElement.call(document, tagName);
      if (tagName.toLowerCase() === 'script') {
        const originalSetAttribute = element.setAttribute;
        element.setAttribute = function(name: string, value: string) {
          if (name === 'src' && value.includes('serviceWorkerRegistration')) {
            console.log('🧹 Blocked script tag with serviceWorkerRegistration');
            return element;
          }
          return originalSetAttribute.call(element, name, value);
        };
      }
      return element;
    };
  }
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
